import { AuthModel } from './auth.model';
import { CompanyModel } from '@modules/auth/register-company/_models/company.model';

export interface UpdateProfileRequest {
  profile: {
    firstName: string;
    lastName: string;
    email: string;
    showOnboarding: boolean;
  };
}

export class UserModel extends AuthModel {
  profile: {
    id: number;
    username: string,
    email: string,
    first_name: string,
    last_name: string,
    roles: string[],
    company?: CompanyModel,
    have_company: boolean,
    enabled: boolean,
    force_change_password: boolean,
    show_onboarding: boolean,
  };

  static jsonToModel(object) {
    const user = new UserModel();

    user.profile = {
      id: object.id,
      username: object.username,
      email: object.email,
      first_name: object.first_name,
      last_name: object.last_name,
      roles: object.roles,
      company: object.company,
      have_company: object.have_company,
      enabled: object.enabled,
      force_change_password: object.force_change_password,
      show_onboarding: object.show_onboarding,
    };

    return user;
  }

  saveToAPI() {
    return {
      profile: {
        id: this.profile.id,
        username: this.profile.username,
        email: this.profile.email,
        first_name: this.profile.first_name,
        last_name: this.profile.last_name,
        roles: this.profile.roles,
        company: this.profile.company,
        have_company: this.profile.have_company,
        enabled: this.profile.enabled,
      }
    };
  }
}
